import { AutocompleteInput, ReferenceInput, Button, useNotify, useRefresh, required } from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { candidateRequests } from "api/candidateApi";
import { administrationRequests } from "api/administrationApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const AdmissionAfterEducationModal = ({ candidacyId, existAdd, disabled }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      candidateRequests.updateCandidacyAdmissionAfterEducation(candidacyId),
      { admissionAfterEducationLevelId: data.admissionAfterEducationLevelId },
      "PUT",
    );
    notify("Успешно добавен прием.", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Добави прием след"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          disabled={disabled}
          startIcon={!existAdd ? <AddIcon /> : <EditIcon />}
          variant="contained"
          size="medium"
          label={!existAdd ? "Добави прием след" : "Редактирай прием след"}
        />
      }
    >
      <ReferenceInput
        source="admissionAfterEducationLevelId"
        reference={administrationRequests.getAdmissionAfterEducationLevelsSelect()}
      >
        <AutocompleteInput
          optionText="name"
          label="Прием след"
          validate={required()}
          fullWidth
        />
      </ReferenceInput>
    </FormModal>
  );
};
export default AdmissionAfterEducationModal;
